import * as moment from 'moment';

export const validateStreetAddressErrors = (name) => {
    // try {
    const regex = RegExp(/^.*$/);
    if (name.length > 0) {
        if (regex.test(name)) {
            return false;
        } else {
            return 'mailing_address.street_address_error';
        }
    } else {
        // setStreetAddressValid(false)
        // setStreetAddressError('mailing_address.street_address_error')
        return 'mailing_address.street_address_error';
    }
    // } catch (e) {
    //     console.log(e)
    //     setIsError(true)
    // }
}

export const validateApartmentErrors = (name, required = false) => {
    const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
    if (name?.length > 0) {
        if (regex.test(name)) {
            return false;

        } else {
            return 'errors.apartment_error_invalid'
        }
    } else {
        return required ? 'errors.apartment_required' : false;
    }
}


export const validateCityErrors = (cityName, required = true) => {
    // try {
    const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
    if (cityName.length > 0) {
        if (regex.test(cityName)) {
            return false
        } else {
            return 'mailing_address.city_error';
            // setCityValid(false)
            // setCityError('mailing_address.city_error_invalid')
        }
    } else {
        return 'mailing_address.city_error';
        // setCityValid(false)
        // setCityError('mailing_address.city_error')
    }
    // } catch (e) {
    //     console.log(e)
    //     setIsError(true)
    // }
}


export const validatePaymentAmountErrors = (amount) => {
    if (!amount) {
        return 'errors.payment_amount_invalid'
    }

    const amountFlt = parseInt(amount);
    if (isNaN(amountFlt)) {
        return 'errors.payment_amount_invalid'
    }

    // multiply by 100 to get value in cents 
    if (amountFlt > 10000 * 100) {
        return 'errors.payment_amount_must_be_less'
    }

    if (amountFlt < 100) {
        return 'errors.payment_amount_must_be_more'
    }

    return false;
}

export const validateFileNumberErrors = (fileNumber) => {
    if (!fileNumber || fileNumber.length !== 6) {
        return 'errors.file_number_empty'
    }
    const regex = RegExp(/^[0-9]{6}$/)
    if (!regex.test(fileNumber)) {
        return 'errors.file_number_invalid'
    }

    return false;
}

export const validateFileNumberVINErrors = (fileNumber) => {
    if (!fileNumber || fileNumber.length < 2 || fileNumber.length > 17) {
        return 'errors.file_number_vin_empty'
    }
    const regex = RegExp(/^[a-zA-Z0-9]*$/)
    if (!regex.test(fileNumber)) {
        return 'errors.file_number_vin_invalid'
    }

    return false;
}


export const validatePostalCodeErrors = (number, country) => {
    // if country is USA then use zip code validation
    if (country === "USA") {
        const regex = RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/)
        if (!regex.test(number)) {
            return 'mailing_address.zip_code_error'
        }
    } else if (country === "Canada") {
        const regex = RegExp(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i)
        if (!regex.test(number)) {
            return 'mailing_address.ns_postal_code_error';
        }
    }
    else {
        const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
        if (!regex.test(number) || number.length > 10 || number.length === 0) {
            return 'mailing_address.ns_postal_code_or_zip_error'
        }
    }
    return false;
}

export const validateFullNameErrors = (name) => {

    const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
    if (name.length === 0) {
        return 'contact_information.full_name_error'
    }
    if (name.length <= 1) {
        return 'contact_information.full_name_error_less_characters';
    }
    if (!regex.test(name)) {
        return 'contact_information.full_name_error_invalid'
    }

    return false;
}

export const validatePhoneNumberErrors = (number) => {
    if (number.length === 0) {
        return 'contact_information.phone_number_error'
    }
    if (number.length !== 12) {
        return 'contact_information.phone_number_error_invalid'
    }
    return false;
}

export const validateEmailErrors = (email) => {
    // eslint-disable-next-line
    const regex = RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    if (email.length === 0) {
        return 'contact_information.email_address_error';
    }
    if (!regex.test(email)) {
        return 'contact_information.email_address_error_invalid';
    }

    return false;
}

export const validateTitleErrors = (title) => {
    if (title.length === 0) {
        return 'mailing_address.email_address_error';
    }

    return false;
}

export const validateCountryErrors = (country) => {
    if (country.length === 0) {
        return 'mailing_address.country_required_error';
    }

    return false;
}

export const validateSpecifyErrors = (specify) => {
    if (specify.length === 0) {
        return 'mailing_address.specify_required_error';
    }

    return false;
}

export const validateProvinceOrStateErrors = (country, provinceOrState) => {
    if (provinceOrState.length === 0) {
        return 'mailing_address.province_or_state_required_error';
    }

    return false;
}

export const validateQuantityErrors = (quantity) => {
    if (!quantity) {
        return 'mailing_address.email_address_error';
    }

    return false;
}

export const validateDateOfBirthErrors = (inputDate) => {
    if (moment(inputDate).isValid()) {
        if (
            !moment(inputDate).isAfter(moment().format('YYYY-MM-DD'), 'day')
        ) {
            return false;
        } else {
            return 'contact_information.date_of_birth_error'
        }
    } else {
        return 'contact_information.date_of_birth_error'
    }
}